// Desktop uses an inset app viewport while mobile keeps native document
// scrolling. Read the CSS flag so layout and scroll ownership change together.
export const isAppFramed = () => {
    const frame = document.getElementById('appViewport');
    return Boolean(frame && window.getComputedStyle(frame).getPropertyValue('--app-framed').trim() === '1');
};

export const getAppViewport = () => {
    if (isAppFramed()) {
        const { top, left, right, bottom, width, height } = document.getElementById('appViewport').getBoundingClientRect();
        return { top, left, right, bottom, width, height };
    }
    return { top: 0, left: 0, right: window.innerWidth, bottom: window.innerHeight, width: window.innerWidth, height: window.innerHeight };
};

const getFramedScroller = () => isAppFramed() ? document.getElementById('appScrollViewport') : null;

export const getAppScrollElement = () => getFramedScroller() || document.scrollingElement || document.documentElement;
export const getAppScrollTarget = () => getFramedScroller() || window;
export const getAppScrollTop = () => getFramedScroller()?.scrollTop ?? window.scrollY;

export const scrollAppTo = (...args) => getAppScrollTarget().scrollTo(...args);

// Convert a screen-space measurement to a position within the app's document.
export const getAppElementScrollTop = element => getAppScrollTop() + element.getBoundingClientRect().top - getAppViewport().top;

export const addAppScrollListener = callback => {
    const onScroll = event => {
        const target = getAppScrollTarget();
        const isAppScroll = target === window
            ? [window, document, getAppScrollElement()].includes(event.target)
            : event.target === target;
        if (isAppScroll) callback(event);
    };
    // Capture sees element scroll events, which do not bubble. Filtering keeps
    // speaker carousels and transcript drawers from acting like page scrolls.
    // Resolve the owner per event so crossing the desktop breakpoint also works.
    window.addEventListener('scroll', onScroll, { capture: true, passive: true });
    return () => window.removeEventListener('scroll', onScroll, true);
};
